module.exports = __webpack_public_path__ + "assets/img/head1-zh.d5c83ebb.png";